import { createApp } from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from "@fortawesome/vue-fontawesome";
import { faEye, faEyeSlash, faComments, faWindowMaximize } from "@fortawesome/free-regular-svg-icons";
import {
	faAngleDoubleLeft,
	faAngleDoubleRight,
	faAngleDown,
	faAngleUp,
	faArrowLeft,
	faArrowRotateLeft,
	faArrowRotateRight,
	faArrowsAltV,
	faBan,
	faBell,
	faBellSlash,
	faBook,
	faChartBar,
	faChartPie,
	faCheck,
	faCheckSquare,
	faChevronCircleDown,
	faChevronCircleRight,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faChevronUp,
	faCircle,
	faClipboard,
	faClipboardCheck,
	faClockRotateLeft,
	faCog,
	faColumns,
	faComment,
	faCommentSlash,
	faCrown,
	faCube,
	faEllipsisV,
	faEnvelope,
	faExclamationCircle,
	faExclamationTriangle,
	faExternalLinkAlt,
	faFileAlt,
	faFileDownload,
	faFileExport,
	faFileLines,
	faFileUpload,
	faGlobe,
	faInfoCircle,
	faList,
	faLock,
	faMinus,
	faMinusSquare,
	faMouse,
	faMousePointer,
	faMugHot,
	faPause,
	faPlay,
	faPlus,
	faPlusSquare,
	faQuestionCircle,
	faRandom,
	faRobot,
	faRocket,
	faRotateLeft,
	faSearchMinus,
	faSearchPlus,
	faShareFromSquare,
	faSlash,
	faSortAmountUp,
	faSpinner,
	faSquare,
	faStop,
	faStopwatch,
	faSync,
	faThumbTack,
	faTimes,
	faTimesCircle,
	faTrash,
	faTrophy,
	faUndo,
	faUndoAlt,
	faUpload,
	faUser,
	faUserCheck,
	faUserSlash,
	faVolumeMute,
	faVolumeUp,
	faArrowRightArrowLeft,
	faArrowRightToBracket,
	faArrowRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import {
	faApple,
	faDiscord,
	faGithub,
	faPatreon,
	faPaypal,
	faTwitch,
	faTwitter,
	faWindows,
	faYoutube,
} from "@fortawesome/free-brands-svg-icons";

library.add(faEye, faEyeSlash, faComments, faWindowMaximize);
library.add(
	faAngleDoubleLeft,
	faAngleDoubleRight,
	faAngleDown,
	faAngleUp,
	faArrowLeft,
	faArrowRotateLeft,
	faArrowRotateRight,
	faArrowsAltV,
	faBan,
	faBell,
	faBellSlash,
	faBook,
	faChartBar,
	faChartPie,
	faCheck,
	faCheckSquare,
	faChevronCircleDown,
	faChevronCircleRight,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faChevronUp,
	faCircle,
	faClipboard,
	faClipboardCheck,
	faClockRotateLeft,
	faCog,
	faColumns,
	faComment,
	faCommentSlash,
	faCrown,
	faCube,
	faEllipsisV,
	faEnvelope,
	faExclamationCircle,
	faExclamationTriangle,
	faExternalLinkAlt,
	faFileAlt,
	faFileDownload,
	faFileExport,
	faFileLines,
	faFileUpload,
	faGlobe,
	faInfoCircle,
	faList,
	faLock,
	faMinus,
	faMinusSquare,
	faMouse,
	faMousePointer,
	faMugHot,
	faPause,
	faPlay,
	faPlus,
	faPlusSquare,
	faQuestionCircle,
	faRandom,
	faRobot,
	faRocket,
	faRotateLeft,
	faSearchMinus,
	faSearchPlus,
	faShareFromSquare,
	faSlash,
	faSortAmountUp,
	faSpinner,
	faSquare,
	faStop,
	faStopwatch,
	faSync,
	faThumbTack,
	faTimes,
	faTimesCircle,
	faTrash,
	faTrophy,
	faUndo,
	faUndoAlt,
	faUpload,
	faUser,
	faUserCheck,
	faUserSlash,
	faVolumeMute,
	faVolumeUp,
	faArrowRightArrowLeft,
	faArrowRightToBracket,
	faArrowRightFromBracket
);
library.add(faGithub, faPaypal, faDiscord, faPatreon, faTwitch, faTwitter, faWindows, faApple, faYoutube);

export const installFontAwesome = (app: ReturnType<typeof createApp>) => {
	app.component("font-awesome-layers", FontAwesomeLayers);
	app.component("font-awesome-layer-text", FontAwesomeLayersText);
	app.component("font-awesome-icon", FontAwesomeIcon);
};
